import { useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { Tooltip } from '@app/components/various/Tooltip';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import { Product } from '@typings';
import React from 'react';

interface Props {
  variant: Product.Standard;
}

export const VariantName = ({ variant }: Props) => {
  const ref = React.useRef(null);
  const { productConfiguration } = useMatrixSettingsContext();
  const isOverflowing = useIsOverflowing(ref);

  if (isDefined(productConfiguration)) {
    return null;
  }

  return (
    <Tooltip content={isOverflowing && variant.variantName}>
      <span ref={ref} className="line-clamp-2 break-all body-4 md:line-clamp-1">
        {variant.variantName || <span className="opacity-0">-</span>}
      </span>
    </Tooltip>
  );
};
